import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";
import { useCallback } from "react";

import {
	$localTemplatePreviewImage,
	$uploadTemplatePreview,
} from "../../internal/templates/template-preview-upload.atom";

/**
 * Hook to read the local template preview image and upload a new one.
 */
export const useTemplatePreviewUpload = (documentId: string | undefined) => {
	const previewLoadable = useAtomValue(loadable($localTemplatePreviewImage(documentId)));
	const previewDataUrl = previewLoadable.state === "hasData" ? previewLoadable.data : null;
	const isLoading = previewLoadable.state === "loading";

	const uploadAtom = useSetAtom($uploadTemplatePreview);

	const uploadPreview = useCallback(
		async (svgContent: string) => {
			if (!documentId) {
				return;
			}
			await uploadAtom({ documentId, svgContent });
		},
		[documentId, uploadAtom]
	);

	return { previewDataUrl, isLoading, uploadPreview };
};
